import { AvatarDropdown, AvatarName } from '@/components/base';
import { Settings as LayoutSettings } from '@ant-design/pro-components';
import { history, RunTimeLayoutConfig } from '@umijs/max';
import React from 'react';
import ENV from '@/conf/env';
import { API_PREFIX, LOGIN_PATH } from '@/conf/constants';
import { errorHandler, requestInterceptor, responseInterceptors } from '@/utils/Request';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import { AuthAccountType, PassportService } from '@/services/PassportService';
import LayoutTabs from '@/layouts/components/LayoutTabs';

// import * as Icons from '@ant-design/icons';

const isDev = process.env.NODE_ENV === 'development';
const loginPath = LOGIN_PATH;

export const getCustomTabs = () => LayoutTabs;

// export const getCustomTabs = customTabs;
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: AuthAccountType;
  loading?: boolean;
  fetchUserInfo?: () => Promise<AuthAccountType | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      return await PassportService.auth({
        skipErrorHandler: true,
      });
    } catch (error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== loginPath) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// export function rootContainer(children) {
//   return (
//     <AntdProvider>
//       {children}
//     </AntdProvider>
//   );
// }

// ProLayout 支持的api https://procomponents.ant.design/components/layout
// @ts-ignore
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  const setSettings = (settings) => {
    setInitialState((v) => ({ ...v, settings }));
    localStorage.setItem('default:settings', JSON.stringify(settings));
  };

  const onCollapse = (collapsed) => {
    const settings: any = initialState?.settings ?? {};
    setSettings({ ...settings, collapsed });
  };

  return {
    // actionsRender: () => [<Question key="doc" />],
    onMenuHeaderClick: () => {},
    // title: Settings.title,
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown menu={true}>{avatarChildren}</AvatarDropdown>;
      },
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name,
    // },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    menuHeaderRender: undefined,
    menuFooterRender: undefined,
    onCollapse,
    // collapsedButtonRender: (collapsed) => (
    //   <CollapsedButton collapsed={collapsed} onCollapse={onCollapse} />
    // ),
    // 自定义 403 页面
    unAccessible: <div>unAccessible</div>,
    ...initialState?.settings,
    // title: (
    //   <Space direction={'vertical'}>
    //     <Typography.Text style={{ color: 'rgba(10, 126, 65, 1)' }}>
    //       中储粮智慧包仓考核管理系统
    //     </Typography.Text>
    //     {/*<Typography.Text style={{ color: 'rgba(10, 126, 65, 1)' }}>*/}
    //     {/*  Evaluation management system for intelligent storage of grain in central storage*/}
    //     {/*</Typography.Text>*/}
    //   </Space>
    // ),
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
  baseURL: ENV.baseURL + API_PREFIX,
  withCredentials: true,
  errorConfig: {
    errorHandler: (error, opts) => {
      errorHandler(error, opts);
    },
  },
  requestInterceptors: [requestInterceptor],
  responseInterceptors: [responseInterceptors],
};
